const filterStringList = (list, query) => {
    const filteredList = list.filter((item) => item.toLowerCase().includes(query));
    return filteredList;
};
const filterCategoriesList = (list, query) => {
    let filteredList = list.categories.map((category) => {
        return Object.assign(Object.assign({}, category), { values: category.values.filter((autocompleteValue) => {
                var _a;
                return autocompleteValue.value.toLowerCase().includes(query) ||
                    ((_a = autocompleteValue.subLabel) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query));
            }) });
    });
    filteredList = filteredList.filter((category) => category.values, length > 0);
    return filteredList;
};
const filterValuesList = (list, query) => {
    const filteredList = list.filter((item) => {
        var _a;
        return item.value.toLowerCase().includes(query) ||
            ((_a = item.subLabel) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query));
    });
    return filteredList;
};
export const AutoCompleteUtils = {
    filterValuesList,
    filterCategoriesList,
    filterStringList,
};
